import VueRouter from 'vue-router';
import { Store } from 'vuex';
import namespaces from '@/store/namespaces';
import { UserActionTypes } from '@sone/sone-frontend-core/src/store/modules/user/actions';

export default (router: VueRouter, store: Store<any>) => {
  router.beforeEach(async (to, from, next) => {
    if (!to.meta.isPublic && !to.meta.isOidcCallback) {
      if (store.getters['oidc/oidcIsAuthenticated'] && store.getters['oidc/oidcAccessToken']) {
        await store.dispatch(`${namespaces.USER}/${UserActionTypes.LOAD_INFO}`);
      }
    }
    next();
  });
};
